import { Grid, useTheme } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import { IconLocation, IconMapPin } from "@tabler/icons-react";

const MxDetailLocation = ({
  city,
  sector,
  address
}: {
  city: string | null;
  sector: string | null;
  address: string | null;
}) => {
  const theme = useTheme();
  const location = `${sector || ""}, ${city || ""} ${address || ""}`;
  return (
    <Grid container gap={1} alignItems={"center"}>
      <Grid item xs={"auto"}>
        <IconMapPin size={18} color={theme.palette.error.main} />
      </Grid>
      <Grid item xs={"auto"}>
        <MxTypography variant="caption" fontWeight={400} color="grey.600">
          {location}
        </MxTypography>
      </Grid>
    </Grid>
  );
};

export default MxDetailLocation;
